import _ from "underscore";

import classNames from "classnames";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import PropTypes from "prop-types";
import React from "react";
import Avatar from "../elements/avatar";
import Tooltip from "../overlays/tooltip";
import Popover from "../overlays/popover";

export default class Facepile extends React.Component {
  static displayName = "Facepile";

  static propTypes = {
    list: PropTypes.arrayOf(PropTypes.object), // of objs: {id:1, label: "Bob can edit", avatar: "<url>"}
    total: PropTypes.number,
    avatarWidth: PropTypes.number,
    popoverContent: PropTypes.func,
    overlayPosition: PropTypes.string,
    moreTooltip: PropTypes.node,
    onAvatarClick: PropTypes.func,
    onMoreClick: PropTypes.func,
  };

  static defaultProps = { avatarWidth: 40 };

  renderAvatar = (item) => {
    return (
      <Avatar
        url={item.avatar}
        width={this.props.avatarWidth}
        className="et--facepile--avatar"
        onClick={() => {
          return typeof this.props.onAvatarClick === "function" ? this.props.onAvatarClick(item) : undefined;
        }}
      />
    );
  };

  renderPopover = (item) => {
    return (
      <Popover
        event="hover"
        position={this.props.overlayPosition || "top"}
        className="et--facepile--popover"
        style={{ height: this.props.avatarWidth }}
        popoverContent={() => {
          return (
            <div className="et--facepile--popover-content">
              {typeof this.props.popoverContent === "function" ? this.props.popoverContent(item) : undefined}
            </div>
          );
        }}
      >
        {this.renderAvatar(item)}
      </Popover>
    );
  };

  renderTooltip = (item, content) => {
    return (
      <Tooltip
        content={item.label}
        position={this.props.overlayPosition || "top"}
        className="et--facepile--tooltip"
        style={{ height: this.props.avatarWidth }}
      >
        {content}
      </Tooltip>
    );
  };

  renderMore = (leftover) => {
    return (
      <div
        className="et--facepile--more"
        style={{
          width: this.props.avatarWidth,
          height: this.props.avatarWidth,
          lineHeight: this.props.avatarWidth + "px",
        }}
        onClick={this.props.onMoreClick}
      >{`+${leftover}`}</div>
    );
  };

  render() {
    const show_popover = !!this.props.popoverContent;
    const leftover = this.props.total - _.size(this.props.list);

    return (
      <div className={classNames("et--facepile", this.props.className)}>
        {_.map(this.props.list, (item) => {
          return (
            <span key={item.id} className="et--facepile--item">
              {show_popover
                ? this.renderPopover(item)
                : item.label
                ? this.renderTooltip(item, this.renderAvatar(item))
                : this.renderAvatar(item)}
            </span>
          );
        })}
        {this.props.total && leftover > 0
          ? this.props.moreTooltip
            ? this.renderTooltip({ label: this.props.moreTooltip }, this.renderMore(leftover))
            : this.renderMore(leftover)
          : undefined}
      </div>
    );
  }
}
